import './cart_total.css';
import { useNavigate } from "react-router-dom";
import { TrashIcon } from "../../assets/icons/TrashIcon";
import { useCart } from "../../context/CartContext";
import { BarLoader } from "../BarLoader/BarLoader";
import { SpinnerLoader } from "../SpinnerLoader/SpinnerLoader";

export const CartTotal = () => {
    //HOOKS
    const { cart, cartLoading, emptyCart } = useCart();
    const navigate = useNavigate();

    return (
        <div className='cart_total_container'>
            <div className='value_container'>
                <p>
                    Discount
                </p>
                <p>
                    ${cart && cart.pricing.discount / 100}
                </p>
            </div>
            <div className='value_container'>
                <p>
                    Subtotal
                </p>
                <p>
                    ${cart && cart.pricing.subtotal / 100}
                </p>
            </div>
            <div className='value_container'>
                <p>
                    Tax
                </p>
                <p>
                    ${cart && cart.pricing.tax / 100}
                </p>
            </div>
            <div className='value_container'>
                <p>
                    Total
                </p>
                <p>
                    ${cart && cart.pricing.total / 100}
                </p>
            </div>

            <div className='cart_submit'>
                <button className='empty' disabled={cartLoading} onClick={emptyCart}>
                    Empty Cart
                    <TrashIcon />
                </button>
                <div className='totalLoader active'>
                    {
                        cartLoading && (
                            <BarLoader />
                        )
                    }
                </div>
                <button className='checkout' disabled={cartLoading} onClick={() => navigate('/checkout', {replace: true})}>
                    <div className='loader active'>
                        {
                            cartLoading && (
                                <SpinnerLoader />
                            )
                        }
                    </div>
                    Continue to Checkout
                </button>
            </div>
        </div>
    );
}